// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchCustomerNoticeSuccess} from 'redux/v1/customerNotice/notice/actions';
import type {NoticeState} from 'redux/v1/customerNotice/notice/NoticeState';
import type {PutCustomerNoticeSuccess} from 'redux/v1/customerNotice/put/actions';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {noticeState} from 'redux/v1/customerNotice/CustomerNoticeState';
import {FETCH_CUSTOMER_NOTICE} from 'redux/v1/customerNotice/notice/actions';
import {PUT_CUSTOMER_NOTICE} from 'redux/v1/customerNotice/put/actions';

export const initialState: NoticeState = {
  loading: false,
};

const actionCreators: ActionHandlers<NoticeState> = {
  [PENDING(FETCH_CUSTOMER_NOTICE)]: (state: NoticeState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_CUSTOMER_NOTICE)]: (
    state: NoticeState,
    action: FetchCustomerNoticeSuccess
  ) => ({
    ...state,
    loading: false,
    notice: action.data === undefined ? '' : action.data,
  }),
  [ERROR(FETCH_CUSTOMER_NOTICE)]: (state: NoticeState, action: any) => ({
    ...state,
    loading: false,
    error: action.error.toJSON().message,
  }),
  [SUCCESS(PUT_CUSTOMER_NOTICE)]: (
    state: NoticeState,
    action: PutCustomerNoticeSuccess
  ) => ({
    ...state,
    notice: action.notice,
  }),
};

export const noticeReducer: Reducer<NoticeState> = // $FlowIgnore
  createReducerUsingActionHandlers<NoticeState>(initialState, actionCreators);

export const customerNoticeLoaded: Selector<boolean> = createSelector(
  noticeState,
  (state: NoticeState) => !state.loading && state.notice !== undefined
);

export const getCustomerNotice: Selector<string> = createSelector(
  [noticeState, customerNoticeLoaded],
  (state: NoticeState, loaded: boolean) =>
    loaded && state?.notice ? state.notice : ''
);
